<template>
  <div>
    <div v-if="isBusy || loading" class="text-center text-danger my-2">
      <b-spinner class="align-middle"></b-spinner>
      <strong class="ml-1">{{ $t('CATALOG_LOADING_LABEL', {catalog: $t('PERMISSIONS')})  | capitalize}}</strong>
    </div>
    <b-card v-else bg-variant="dark" text-variant="light" :title="$t('PERMISSIONS') | capitalize">
      <b-card-text>
        <b-button id="open-permission-selector-button" class="mb-2" variant="info" @click="showModal">
          {{ $t('FORMS_MULTI_SELECT_LABEL', {catalog: $t('PERMISSIONS')}) | capitalize}}
        </b-button>
        <b-list-group>
          <b-list-group-item variant="dark" :key="permission.id" v-for="(permission, idx) of current">
            <div class="w-100">
              <div class="w-75 d-inline-block">
                {{ $t(permission.authority) | capitalize}}
              </div>
              <div class="w-25 d-inline-block text-right">
                <b-button variant="danger" @click="removePermission(idx)">
                  <b-icon-x-circle></b-icon-x-circle>
                </b-button>
              </div>
            </div>
          </b-list-group-item>
        </b-list-group>
        <b-modal :title="$t('FORMS_MULTI_SELECT_LABEL', {catalog: $t('PERMISSIONS')})" id="permission-modal" size="xl" @ok="handleInput">
          <permission-list @change="storeSelected"></permission-list>
        </b-modal>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import {LoadData, SendsMessages, VModel} from "@/mixins";
import PermissionList from "./PermissionList";

export default {
  name: "PermissionSelector",
  components: {PermissionList},
  props: ['loading', 'value', 'initialValues'],
  mixins: [LoadData, VModel, SendsMessages],
  mounted() {
    this.currentHrefs = this.value;
    this.current = this.initialValues;
  },
  watch: {
    value(val) {
      this.currentHrefs = val;
    },
    initialValues(val) {
      this.current = val;
    }
  },
  methods: {
    removePermission(idx) {
      this.current.splice(idx, 1);
      this.currentHrefs.splice(idx, 1);
      this.$emit('input', this.currentHrefs);
    },
    storeSelected(selected) {
      this.selected = selected;
      this.selectedHrefs = selected.map(x => x._links.self.href);
    },
    async showModal() {
      this.$bvModal.show('permission-modal');
    },
    handleInput() {
      this.selected.forEach(sel => {
        const idx = this.current.map(x => x.authority).indexOf(sel.authority);
        if(idx === -1) {
          this.current.push(sel)
        }
      });
      this.currentHrefs = this.current.map(x => x._links.self.href)
      this.$emit('input', this.currentHrefs);
      this.selected = [];
      this.selectedHrefs = [];
    }
  },
  data() {
    return {
      search: '',
      permissions: [],
      content: this.value,
      selected: [],
      selectedHrefs: [],
      current: [],
      currentHrefs: []
    }
  },
}
</script>

<style scoped>

</style>
